import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import ReactApexChart from 'react-apexcharts';

function PieChart(props) {
    const { t } = useTranslation();

    const {
        inputParam_DataserieChartItem = null,
    } = props;

    let totalBadValue = 0;
    let totalRegularValue = 0;
    let totalFineValue = 0;

    for (let index = 0; index < inputParam_DataserieChartItem.length; index++) {
        const element = inputParam_DataserieChartItem[index];
    
        totalBadValue = totalBadValue += (element.nTotalDataserie_badvalue !== undefined ? element.nTotalDataserie_badvalue : 0);
        totalRegularValue = totalRegularValue += (element.nTotalDataserie_regularvalue !== undefined ? element.nTotalDataserie_regularvalue : 0);
        totalFineValue = totalFineValue += (element.nTotalDataserie_finevalue !== undefined ? element.nTotalDataserie_finevalue : 0);
    }

    const [dataserie, setDataserie] = useState({
        series: [totalBadValue, totalRegularValue, totalFineValue],
        options: {
            chart: {
                type: 'donut',
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }],
            colors: ['#d93b3b', '#ECA700', '#25aa34'],
            labels: [t('data-lang-lbl-totalbadvalue-long'), t('data-lang-lbl-totalregularvalue-long'), t('data-lang-lbl-totalfinevalue-long')],
        },
    })

    return (
        <>
            <Card className='mb-1'>
                <Card.Header className="card-header-compact">
                    <Card.Title className="d-flex justify-content-between">
                        <b>{t('data-lang-boxname-homechartpie')}</b>
                    </Card.Title>
                </Card.Header>
                <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    <div className='book-toolbar d-flex float-end'>
                    </div>
                </Card.Footer>
                <Card.Body className="h-100">
                    <div>
                        <ReactApexChart options={dataserie.options} series={dataserie.series} type="donut" height={350} />
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}

PieChart.propTypes = {
    inputParam_DataserieChartItem: PropTypes.array.isRequired,
    inputParam_VariableName: PropTypes.string,
};

export default PieChart;